import { Project } from 'src/modules/common/types/Project';

export function getExportProjectFilename(
  project: Project,
  now: Date,
): string {
  return [
    project.data.title,
    ' ',
    now.getFullYear(),
    String(now.getMonth() + 1).padStart(2, '0'),
    String(now.getDate()).padStart(2, '0'),
    ' ',
    String(now.getHours()).padStart(2, '0'),
    String(now.getMinutes()).padStart(2, '0'),
  ].join('');
}
